export default "__VITE_ASSET__$lH4he_w__"